var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainImgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.4 33.4",
    style: {
      enableBackground: "new 0 0 13.4 33.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3982",
    transform: "translate(-1062 -734.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    className: "st0",
    d: "M1062.7,760.3l6,6l6-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_124",
    className: "st0",
    d: "M1068.7,766.3v-32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgArrow);
export default __webpack_public_path__ + "static/media/main_img_arrow.212a09d03e32f4ca4c9a82f991d9b2f3.svg";
export { ForwardRef as ReactComponent };